import { render } from "./story_filter_bar.vue?vue&type=template&id=58a5fac4&lang=pug"
import script from "./story_filter_bar.vue?vue&type=script&lang=js"
export * from "./story_filter_bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__